function initialValues({ productionOrder }) {
  return {
    productionOrderId: productionOrder.id,
    scanStatus: null,
    haveCurrentSet: null,
    howOftenWear: null,
    userIssue: null,
    arch: null,
    upperArchFit: null,
    lowerArchFit: null,
    message: null,
    warrantyImagesAttributes: [],
    whereToShip: 'patient_address',
  };
}

export default initialValues;
